const STATUS_BADGE = {
  queued:    "bg-slate-100 text-slate-600",
  running:   "bg-blue-100 text-blue-600",
  completed: "bg-green-100 text-green-700",
  failed:    "bg-red-100 text-red-600",
};

const StatusBadge = ({ status }) => (
  <span
    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold capitalize ${STATUS_BADGE[status] ?? "bg-slate-100 text-slate-500"}`}
  >
    {status}
  </span>
);

export default StatusBadge;
